/**
 * @file 文档页页左侧菜单
 * @author wanzhongyun
 */

import React, {useCallback} from 'react';
import {Menu, Tooltip} from 'antd';
import {MenuProps} from 'antd/es/menu';
import {ExclamationCircleFilled} from '@ant-design/icons';

import LinkA from '../../../../components/a/LinkA';
import {IDocumentMenuItem} from '../../type';


const renderSubMenu = (menuList: IDocumentMenuItem[]) => (
    menuList.map(menuItem => {
        const isDataset = menuItem.title === 'paddle.dataset';
        const isFluid = menuItem.title === 'paddle.fluid';
        if (menuItem.children.length > 0) {
            return (
                <Menu.SubMenu
                    key={menuItem.key}
                    icon={<i className="paddle-doc-page-left-menu-arrow" />}
                    title={
                        <LinkA to={menuItem.link || ''}>
                            {menuItem.title}
                            {isDataset
                            && (
                                <Tooltip
                                    placement="bottom"
                                    title="paddle.dataset will be deprecated in the future. Please use paddle.version.dataset and paddle.text.datasets instead."
                                >
                                    <ExclamationCircleFilled
                                        style={{marginLeft: 5}}
                                    />
                                </Tooltip>
                            )}
                            {isFluid
                            && (
                                <Tooltip
                                    placement="bottom"
                                    title={
                                        window.location.pathname.includes('/2.5') || window.location.pathname.includes('/develop')
                                            ? "paddle.fluid has been deprecated. Please use other alternative APIs."
                                            : "paddle.fluid will be deprecated in the future. Please use other alternative APIs."
                                        }
                                >
                                    <ExclamationCircleFilled
                                        style={{marginLeft: 5}}
                                    />
                                </Tooltip>
                            )}
                        </LinkA>
                    }
                >
                    {renderSubMenu(menuItem.children)}
                </Menu.SubMenu>
            );
        }
        return (
            <Menu.Item key={menuItem.key}>
                <LinkA to={menuItem.link || ''}>
                    {menuItem.title}
                </LinkA>
            </Menu.Item>
        );
    })
);


export interface IDocLeftMenuProps {
    subMenuOpenKeys: string[];
    subMenuSelectedKeys: string[];
    subMenuList: IDocumentMenuItem[];

    setSubMenuOpenKeys: (openKeys: string[]) => void;
}

const DocLeftMenu: React.FC<IDocLeftMenuProps> = props => {
    const {
        subMenuOpenKeys,
        subMenuSelectedKeys,
        subMenuList,
        setSubMenuOpenKeys
    } = props;

    const onOpenChange = useCallback<Exclude<MenuProps['onOpenChange'], undefined>>(
        (keys) => {
            setSubMenuOpenKeys(keys.map(k => '' + k));
        },
        [setSubMenuOpenKeys]
    );

    return (
        <Menu
            className="paddle-doc-page-left-menu"
            mode="inline"
            selectedKeys={subMenuSelectedKeys}
            inlineIndent={16}
            openKeys={subMenuOpenKeys}
            onOpenChange={onOpenChange}
            expandIcon={<React.Fragment />}
        >
            {renderSubMenu(subMenuList)}
        </Menu>
    );
};

export default DocLeftMenu;
